export default "__VITE_ASSET__BqEKFoXo__"